"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.romaniaTranslations = void 0;
var _types = require("../../../types");
const romaniaTranslations = exports.romaniaTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Ne pare rău!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Înapoi',
  [_types.ErrorPageTranslationKey.text]: 'Pagina nu este disponibilă la moment',
  [_types.ErrorPageTranslationKey.notFound]: 'Pagina pe care ai accesat-o nu a putut fi găsită',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Pagina pe care doreşti să o accesezi este restricţionată.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Te rugăm să contactezi echipa de suport Oriflame prin email:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Adresa URL solicitată a fost respinsă!'
};
